/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Maintainer_ProfileInputs */

const en_contact_maintainer_profile = /** @type {(inputs: Contact_Maintainer_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer profile`)
};

const ko_contact_maintainer_profile = /** @type {(inputs: Contact_Maintainer_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발자 프로필`)
};

const ja_contact_maintainer_profile = /** @type {(inputs: Contact_Maintainer_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者プロフィール`)
};

/**
* | output |
* | --- |
* | "Developer profile" |
*
* @param {Contact_Maintainer_ProfileInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_maintainer_profile = /** @type {((inputs?: Contact_Maintainer_ProfileInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Maintainer_ProfileInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_maintainer_profile(inputs)
	if (locale === "ko") return ko_contact_maintainer_profile(inputs)
	return ja_contact_maintainer_profile(inputs)
});